// https://codepen.io/lehollandaisvolant/pen/ryrrGx

const stickyFacetBar = {
    // Initial state
    scrollPos: 0,
    bindHandler() {
        // TODO: add a throttle or delay
        window.addEventListener('scroll', () => {
            let bodyTopPosition = document.body.getBoundingClientRect().top;
            // detects new state and compares it with the new one
            if (bodyTopPosition > this.scrollPos && bodyTopPosition < 0) {
                // scrolling up
                $('.filter-bar--container')
                        .addClass('filter-bar--sticky')
                        .css({'top': $('.page-header').height() + 'px'});
            } else {
                $('.filter-bar--container')
                        .removeClass('filter-bar--sticky')
                        .css({'top': ''});
            }
            // saves the new position for iteration.
            this.scrollPos = bodyTopPosition;
        });
        // avoid dropdown menu close on click inside
        $(document.body).on('click', '.filter-bar .dropdown-menu', (evt) => {
            evt.stopPropagation();
        });
    }
};

$(() => {
    if ($('#product-grid-page').length) {
        stickyFacetBar.bindHandler();
    }
});

export default stickyFacetBar;
